export enum SelectSchoolMode {
  chooseinlist,
  createnew,
}

export enum SelectSchoolField {
  mode = 'mode',
  existingSchool = 'existingSchool',
  name = 'name',
  streetAddress = 'streetAddress',
  postalCode = 'postalCode',
  city = 'city',
}
